import "bootstrap-icons/font/bootstrap-icons.css";
import "./whyChoseUs.css";
import Reveal from "../../utils/Reveal";
import blackMap from "../../../assets/images/blackmap.png";

const WhyChooseUs = () => {
  return (
    <div className="container d-flex flex-column pt-5" style={{ zIndex: 2 }}>
      <h3 className="fw-bold  mb-5 choose-us-text text-decoration-underline text-center">
        Why choose IPG AERO Consulting and Brokers - FZCO?
      </h3>

      <h4 className="text-start fw-bold choose-us-text px-2">
        Global Coverage
      </h4>
      <p className="fw-medium choose-us-text px-2">
        {" "}
        IPG Aero Consulting and Brokers - FZCO boasts a robust global presence,
        ensuring seamless logistics solutions across key regions:
      </p>

      <div className="row d-flex flex-wrap flex-row">
        <div className="row d-flex flex-wrap">
          <div className="col-sm-12 col-lg-6 order-2 order-md-1">
            <Reveal animationType="fadeInRight">
              <div>
                <ul className="list-unstyled">
                  <li className="fw-medium pb-2">
                    <span className="d-flex flex-column">
                      <span>
                        <i
                          className="bi bi-check-lg me-2"
                          style={{ color: "black", fontWeight: "bold" }}
                        ></i>
                        <span
                          style={{ fontStyle: "italic", fontSize: "20px" }}
                          className="choose-us-text"
                        >
                          Europe
                        </span>
                      </span>
                      <span
                        style={{ paddingLeft: "25px" }}
                        className="text-light"
                      >
                        With strategically located facilities and partners
                        throughout Europe, we facilitate efficient
                        intra-continental transport and distribution, catering
                        to major markets and emerging hubs alike.​
                      </span>
                    </span>
                  </li>
                  <li className="fw-medium pb-2">
                    <span className="d-flex flex-column">
                      <span>
                        <i
                          className="bi bi-check-lg me-2"
                          style={{ color: "black", fontWeight: "bold" }}
                        ></i>
                        <span
                          style={{ fontStyle: "italic", fontSize: "20px" }}
                          className="choose-us-text"
                        >
                          United States
                        </span>
                      </span>
                      <span
                        style={{ paddingLeft: "25px" }}
                        className="text-light"
                      >
                        Our extensive network across the U.S. enables us to
                        manage complex supply chains, offering nationwide
                        coverage and access to critical technological markets.​
                      </span>
                    </span>
                  </li>
                  <li className="fw-medium pb-2">
                    <span className="d-flex flex-column">
                      <span>
                        <i
                          className="bi bi-check-lg me-2"
                          style={{ color: "black", fontWeight: "bold" }}
                        ></i>
                        <span
                          style={{ fontStyle: "italic", fontSize: "20px" }}
                          className="choose-us-text"
                        >
                          Asia
                        </span>
                      </span>
                      <span
                        style={{ paddingLeft: "25px" }}
                        className="text-light"
                      >
                        Asia's pivotal role in the high-tech industry, we have
                        established strong partnerships and operations in key
                        Asian markets, ensuring timely and secure delivery
                        within the region and beyond.​
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </Reveal>
          </div>
          <div className="col-sm-12 col-lg-6 order-1 order-md-2">
            <div className="continents-image">
              <img src={blackMap} alt="" className="w-100 rounded img-fluid" />
            </div>
          </div>
        </div>
        <Reveal>
          <div
            className=" text-light d-flex justify-center items-center p-5"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <ul className="list-group fw-medium" style={{ fontSize: "16px" }}>
              <li>
                <span
                  className="choose-us-text"
                  style={{ fontStyle: "italic", fontSize: "18px" }}
                >
                  Specialization:
                </span>{" "}
                Dedicated focus on high-tech logistics security
              </li>
              <li>
                <span
                  className="choose-us-text"
                  style={{ fontStyle: "italic", fontSize: "18px" }}
                >
                  Certified network:
                </span>{" "}
                TAPA and other industry-recognized standards
              </li>
              <li>
                <span
                  className="choose-us-text"
                  style={{ fontStyle: "italic", fontSize: "18px" }}
                >
                  Experience:
                </span>{" "}
                Proven track record protecting valuable technology
              </li>
              <li>
                <span
                  className="choose-us-text"
                  style={{ fontStyle: "italic", fontSize: "18px" }}
                >
                  Global Reach:
                </span>{" "}
                Seamless security across international movements
              </li>

              <li>
                <span
                  className="choose-us-text"
                  style={{ fontStyle: "italic", fontSize: "18px" }}
                >
                  24/7 Availability:
                </span>{" "}
                <span className="text-light">
                  Always-on service meeting urgent requirements
                </span>
              </li>
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default WhyChooseUs;
